import { useEffect } from "react";
import Lenis from "lenis";
import Navbar from "@/components/Navbar";
import Hero from "@/components/Hero";
import Marquee from "@/components/Marquee";
import Services from "@/components/Services";
import Process from "@/components/Process";
import Gallery from "@/components/Gallery";
import Pricing from "@/components/Pricing";
import TrustFaq from "@/components/TrustFaq";
import Contact from "@/components/Contact";
import Footer from "@/components/Footer";

export default function Home() {
  useEffect(() => {
    const lenis = new Lenis({ lerp: 0.09, smoothWheel: true });
    let rafId;
    const loop = (time) => {
      lenis.raf(time);
      rafId = requestAnimationFrame(loop);
    };
    rafId = requestAnimationFrame(loop);
    return () => {
      cancelAnimationFrame(rafId);
      lenis.destroy();
    };
  }, []);

  return (
    <main data-testid="home-page" className="grain bg-obsidian text-gray-100 font-sans overflow-x-clip">
      <Navbar />
      <Hero />
      <Marquee />
      <Services />
      <Process />
      <Gallery />
      <Pricing />
      <TrustFaq />
      <Contact />
      <Footer />
    </main>
  );
}
